import { metricsBus } from "@/common/buses";
import localMetrics from "@/common/services/localMetrics/localMetrics";

metricsBus.on("gifView", (props) => localMetrics.sendGifView(props));
metricsBus.on("gifPlayback", (props) => localMetrics.sendGifPlayback(props));
metricsBus.on("gifShared", (props) => localMetrics.sendGifShared(props));
metricsBus.on("addedToCollection", (props) => localMetrics.sendGifAddedToCollection(props));
metricsBus.on("gifLiked", (props) => localMetrics.sendGifLiked(props));
metricsBus.on("profileClicked", (props) => localMetrics.sendProfileClicked(props));
metricsBus.on("followUserClicked", (props) => localMetrics.sendFollowUserClicked(props));
metricsBus.on("dailyVisit", (props) => localMetrics.sendDailyVisit(props));
metricsBus.on("boostProfileClicked", (props) => localMetrics.sendBoostProfileClicked(props));
